import AUSPGAccessCodeModal from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/SPGAccessCodeModal/AUSPGAccessCodeModal';
import NZSPGAccessCodeModal from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/SPGAccessCodeModal/NZSPGAccessCodeModal';

export { AUSPGAccessCodeModal };
export { NZSPGAccessCodeModal };
